module.exports = __webpack_public_path__ + "img/memories.6482005b.jpeg";